import React, { useMemo } from 'react';
import * as THREE from 'three';

interface EdgeProtectorProps {
    position: [number, number, number];
    rotation?: [number, number, number];
    color?: string;
    width?: number;
    depth?: number;
}

const EdgeProtector: React.FC<EdgeProtectorProps> = ({
    position,
    rotation = [0, 0, 0],
    color = '#facc15', // Vibrant yellow (safety color)
    width = 0.25,      // Width across the strap
    depth = 0.15       // Length along each side of the L-shape
}) => {
    const thickness = 0.02;

    return (
        <group position={position} rotation={rotation}>
            {/* Horizontal part on top of cargo */}
            <mesh position={[0, thickness / 2, -depth / 2]}>
                <boxGeometry args={[width, thickness, depth]} />
                <meshStandardMaterial color={color} roughness={0.6} />
            </mesh>
            {/* Vertical part on side of cargo */}
            <mesh position={[0, -depth / 2, thickness / 2]} rotation={[Math.PI / 2, 0, 0]}>
                <boxGeometry args={[width, thickness, depth]} />
                <meshStandardMaterial color={color} roughness={0.6} />
            </mesh>

            {/* Safety stripes (subtle detail) */}
            <mesh position={[0, thickness / 2 + 0.001, -depth / 2]}>
                <planeGeometry args={[width, depth]} />
                <meshBasicMaterial color="#000000" opacity={0.15} transparent />
            </mesh>
        </group>
    );
};

export default EdgeProtector;
